import * as React from "react";
import { ExternalLink as ExternalLinkIcon } from "react-feather";
import { CopyButtonWithApproval } from "../../../pages/domain/create_ng/copyButtonWithApproval";

export interface ExternalLinkProps {
  url: string;
  label: string;
  disableCopy?: boolean;
  className?: string;
}
export const ExternalLink: React.FC<ExternalLinkProps> = ({ url, label, className = "", disableCopy = false }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <a className="truncate color-link ngfocus" href={url} target={"_blank"}>
        <span>{label}</span>
        <ExternalLinkIcon className={`inline-block feather-icon ml-1`} style={{ transform: "translateY(2px)" }} />
      </a>
      {disableCopy ? null : <CopyButtonWithApproval value={url} />}
    </div>
  );
};
